<template>
  <div>
    <Menu_Setting/>
    <Unit_Setting/>
  </div>
</template>

<script>
import Menu_Setting from "@/components/admin/setting_product/menu_setting/Menu_Setting.vue";
import Unit_Setting from "@/components/admin/setting_product/Unit_Setting.vue";
export default {
  name: "UnitSetting",
  components: {
    Unit_Setting,
    Menu_Setting
  }
}
</script>

<style scoped>

</style>